module.exports = __webpack_public_path__ + "img/Flecha-derecha-blanca.0a6402ad.svg";